import { render, staticRenderFns } from "./upload_media.vue?vue&type=template&id=72dd92ca&scoped=true&"
import script from "./upload_media.vue?vue&type=script&lang=js&"
export * from "./upload_media.vue?vue&type=script&lang=js&"
import style0 from "./upload_media.vue?vue&type=style&index=0&id=72dd92ca&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72dd92ca",
  null
  
)

export default component.exports